module.exports = __webpack_public_path__ + "./fonts/SF-Pro-Text-Medium.otf";